import router from './router'
import store from './store'
import {
	Message
} from 'element-ui'
import {
	getToken
} from './utils/auth.js' // getToken from cookie


// permission judge function
function hasPermission(perms, permissions) {
	if (perms.indexOf('*') >= 0) return true // admin permission passed directly
	if (!permissions) return true
	return perms.some(perm => permissions.indexOf(perm) >= 0)
}
const whiteList = ['/','/login', '/auth-redirect','/register','/bj-smart-fill'] // no redirect whitelist
// router.
router.beforeEach((to, from, next) => {
	
	if (getToken()) { // determine if there has token
		/* has token*/
		if (to.path === '/login') {
			next({
				path: '/'
			})
		} else {
			if (store.getters.perms.length === 0) { // 判断当前用户是否已拉取完user_info信息
				store.dispatch('GetUserInfo').then(res => { // 拉取user_info
					let perms = [];
					if(res.data.data.roles&&res.data.data.roles.length>0){
						if(res.data.data.permissions == null){
							perms = ['普通']
						}else{
						perms = res.data.data.permissions
					}
					} // note: perms must be a array! such as: ['GET /aaa','POST /bbb']
					store.dispatch('GenerateRoutes', {
						perms
					}).then(() => { // 根据perms权限生成可访问的路由表
						router.addRoutes(store.getters.addRoutes) // 动态添加可访问路由表
						next({
							...to,
							replace: false
						}) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
					})
				}).catch((err) => {
					store.dispatch('FedLogOut').then(() => {
						Message.error(err || 'Verification failed, please login again')
						next({
							path: '/'
						})
					})
				})
			} else {
				// 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
				if (hasPermission(store.getters.perms, to.meta.perms)) {
					next()
				} else {
					next({
						path: '/404',
						replace: true,
						query: {
							noGoBack: true
						}
					})
				}
				// 可删 ↑
			}
		}
	} else {
		/* has no token*/
		if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
			next()
		} else {
			// next()
			next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
		}


	}
})

router.afterEach(() => {

})